import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../StoreSelector.css';
import './NewStoreSelector.css';
import Segment from 'semantic-ui-react/dist/es/elements/Segment';
import Header from 'semantic-ui-react/dist/es/elements/Header';

import 'semantic-ui-css/components/header.min.css';
import 'semantic-ui-css/components/segment.min.css';
import StoreSelectorMenuItem from './StoreSelectorMenuItem';
import { Tab } from 'semantic-ui-react';
import CurrentStoreMenuItem from './CurrentStoreMenuItem';
import { getDirectoryMenu } from '../../../../utils/StaticAssetManager';
import CurrentStoreFloorMenuItem from './CurrentStoreFloorMenuItem';
import CurrentStoreMenuItemGrid from './CurrentStoreMenuItemGrid';

/**
    Default store selector used by all new stores, as long as they follow the pattern of only linking scenes insteda of
    linking stores
 */
class StoreSelectorMenu extends Component {
    constructor(props) {
        super(props);
        this.hide = this.hide.bind(this);
    }

    hide() {
        this.setState({ visible: false });
    }

    renderMenuItems = () => {
        const { linkedStores, currentStoreIndex, sceneIdNameDict, menuTextFontStyle, closeMenu } = this.props;

        <Segment.Group>
            <CurrentStoreMenuItem
                menuTextFontStyle={menuTextFontStyle}
                sceneIdNameDict={sceneIdNameDict}
                closeMenu={closeMenu}
            />
        </Segment.Group>
    }

    renderFloorMenuItems = () => {
        const { sceneIdNameDict, menuTextFontStyle, closeMenu} = this.props;
        const MenuItem = CurrentStoreFloorMenuItem;
        return (
            <Segment.Group>
                <MenuItem
                    menuTextFontStyle={menuTextFontStyle}
                    sceneIdNameDict={sceneIdNameDict}
                    closeMenu={closeMenu}
                    itemType="floor"
                />
            </Segment.Group>
        );

    }

    renderMenuItemsGrid = () => {
        const { linkedStores, currentStoreIndex, sceneIdNameDict, menuTextFontStyle, closeMenu } = this.props;
        return ( 
            <CurrentStoreMenuItemGrid
                menuTextFontStyle={menuTextFontStyle}
                sceneIdNameDict={sceneIdNameDict}
                closeMenu={closeMenu}
            />
        );
    }

    render() {
        const { showMenu, menuTitleFontStyle, selectorTitle } = this.props;
        if (!showMenu) {
            return (<div />);
        }
        return (
            <React.Fragment>
                <div id='store-selector-arrow' style={{marginLeft: 'auto', marginRight: '10px'}}/>
                <div id='storeSelectorMenu' style={{ backgroundColor: '#E1E1E5' }} className={'store-menu-tab'}>
                    {/* <Tab panes={[
                        {
                            menuItem: 'SECTIONS',
                            render: () =>
                                <Tab.Pane className='menu-tab'>
                                    {this.renderMenuItems()}
                                </Tab.Pane>
                        },
                        {
                            menuItem: 'FLOOR PLAN',
                            render: () =>
                                <Tab.Pane className='menu-tab'>
                                    {this.renderFloorMenuItems()}
                                </Tab.Pane>
                        }
                    ]} /> */}
                    {this.renderMenuItemsGrid()}

                </div>
            </React.Fragment>
        );
    }
}

StoreSelectorMenu.propTypes = {
    showMenu: PropTypes.bool,
    linkedStores: PropTypes.array,
    currentStoreIndex: PropTypes.number,
    menuTextFontStyle: PropTypes.object,
    menuTitleFontStyle: PropTypes.object,
    menuTitle: PropTypes.string,
    sceneIdNameDict: PropTypes.object,
    closeMenu: PropTypes.func
};

export default StoreSelectorMenu;
